<template>
  <div class='dean-form-row' :class="{hiddenLabel: hideLabel}">
    <div class='row partnerSelect' :class="{hiddenLabel: hideLabel}">
      <div :class="{
        ['small-6 medium-6 large-6 hd-6 columns']: !fullWidth,
        ['small-12 medium-12 large-12 hd-12 columns']: fullWidth
      }" v-if="!hideLabel">
        <p class='input-label'> <span v-html="label"></span> <span style="color:red">{{requiredField ? '*' : ''}}</span></p>
      </div>
      <div :class="{
        ['small-6 medium-6 large-6 hd-6 columns']: !hideLabel,
        ['small-12 medium-12 large-12 hd-12 columns']: hideLabel || fullWidth
      }">
        <v-select :placeholder="placeholderWithRequired"
                  :multiple="multiple"
                  :disabled="disabled"
                  :id='id'
                  label="label"
                  :clearable="clearable !== undefined ? clearable : true"
                  :options='options' :value='value' @input='propagateInput'
                  :class="validationClass"
                  appendToBody
                  :dropdownOpen="true"></v-select>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  // VUE
  import {Vue, Component, Prop} from 'vue-property-decorator';
  import vSelect from 'vue-select';

  // COMPONENTS
  @Component({
    components: {
      vSelect
    },
  })

  export default class deanSelectFormRow extends Vue {
    @Prop() private options?: any[];
    @Prop() private value?: any;
    @Prop() private placeholder?: string;
    @Prop() private label?: string;
    @Prop() private id?: string;
    @Prop() private multiple?: boolean;
    @Prop() private disabled?: boolean;
    @Prop({default: false}) private clearable?: boolean;
    @Prop({default: false}) private hideLabel?: boolean;
    @Prop({default: false}) private fullWidth?: boolean;
    @Prop({default: false}) protected warning!: boolean;
    @Prop({default: false}) protected requiredField!: boolean;

    get validationClass() {
      return this.warning ? 'warning' : '';
    }

    get placeholderWithRequired() {
      let placeholder = this.placeholder;
      return this.requiredField ? placeholder + ' *' : placeholder;
    }

    public propagateInput(input: any) {
      input = input ? input : '';
      this.$emit('input', input);
    }
  }
</script>

<style lang='scss' scoped>
  p.input-label {
    padding-left: 15px;
  }
</style>

<style lang="scss">
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
  @import '~vue-select/src/scss/vue-select';

  .vs--searchable {
    padding: 5px 10px 5px 10px;
    border-radius: 10px;

    .vs__selected {
      overflow: hidden;
      margin: 8px 2px;
    }

    .vs__selected-options {
      overflow: hidden;
    }

    .vs__dropdown-toggle {
      height: 40px;
      background: none;
      background: -webkit-gradient(linear, right top, left top, color-stop(50%, #FFF), color-stop(50%, #f9f9f9));
      background: linear-gradient(to left, #FFF 50%, #f9f9f9 50%);
      background-size: 200% 100%;
      background-position: right bottom;
      border: 1px solid #F5F5F5;
      width: 100%;
      border-radius: 10px;
      -webkit-transition: all ease 0.8s;
      transition: all ease 0.8s;
    }
  }

  .hiddenLabel {
    min-width: 150px;
  }

  .warning {
    .vs__dropdown-toggle {
      border: 1px solid var(--color-info-warning, $color-info-warning) !important;
    }
  }
</style>
